import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c9ea78c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "plan-monthly-price" }
const _hoisted_3 = { class: "plan-monthly-original-price" }
const _hoisted_4 = {
  key: 1,
  class: "wrapper"
}
const _hoisted_5 = { class: "plan-content" }
const _hoisted_6 = { class: "plan-monthly-price" }
const _hoisted_7 = { class: "plan-monthly-original-price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isMobile && _ctx.isSamePlan())
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: "wrapper",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.planSelected && _ctx.planSelected(...args))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.planSelected && _ctx.planSelected(...args)), ["enter"]))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.discountStyle())
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.promoText()), 1)
        ], 2),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", null, _toDisplayString(_ctx.planType()), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.price) + "€", 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.afterPriceText()), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_ctx.nextPaymentText()), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.priceMonthAfter()), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.nextPaymentText()), 1)
          ])
        ])
      ], 32))
    : (_ctx.isSamePlan())
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.discountStyle())
          }, [
            _createElementVNode("p", null, _toDisplayString(_ctx.promo), 1)
          ], 2),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(_ctx.planType()), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.price) + "€", 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.afterPriceText()), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(_ctx.nextPaymentText()), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.priceMonthAfter()), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.nextPaymentText()) + " " + _toDisplayString(_ctx.priceMonthAfter()), 1)
            ])
          ]),
          _createElementVNode("button", {
            class: "button-submit",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.planSelected && _ctx.planSelected(...args)))
          }, _toDisplayString(_ctx.promoText()), 1)
        ]))
      : _createCommentVNode("", true)
}